/*
 * Chapter activity links for the Inbox, including unread and next-turn summaries.
 * prepareChapterActivity converts the shared activity snapshot into the text and
 * accessibility labels rendered by ChapterActivity; it does not fetch chapters.
 * Used by the Inbox menu and the chapter activity fixtures.
 * Example: <ChapterActivity state={prepareChapterActivity(snapshot)} onNavigate={navigate}/>
 */

import { chapterStoryLabel } from '../../lib/chapters/story-memberships.js';

export function prepareChapterActivity(state) {
  return {
    empty: !state.loaded
      ? state.error
        ? 'Could not load chapters.'
        : 'Loading…'
      : 'No active chapters.',
    rows: state.chapters.map((chapter) => {
      const activity = chapter.activity;
      const next = chapter.turn_order_mode !== 'none' ? chapter.next_turn || [] : [];
      return {
        id: chapter.id,
        title: chapter.title,
        activity,
        label: [
          activity.unread && 'New Activity',
          activity.yourTurn && (activity.pulse ? 'Your Turn — not yet acknowledged' : 'Your Turn')
        ]
          .filter(Boolean)
          .join('; '),
        status: [activity.unread && 'New Activity', activity.yourTurn && 'Your Turn']
          .filter(Boolean)
          .join(' · '),
        next: next.length
          ? `Next: ${next.map((character) => `${character.character_name} (${character.username || 'unassigned'})`).join(', ')}`
          : '',
        story: chapterStoryLabel(chapter) || 'Draft'
      };
    })
  };
}

export function ChapterActivity({ state, onNavigate }) {
  return state.rows.length ? (
    state.rows.map((chapter) => (
      <a key={chapter.id} href={`/chapters/${chapter.id}`} class="menu-item chapter-activity-row" data-chapter-id={chapter.id} onClick={(event) => onNavigate(event, chapter.id)}>
        <strong>
          <span>{chapter.title}</span>
          <span
            class={`activity-dot chapter-activity-row-dot${chapter.activity.pulse ? ' chapter-activity-pulse' : ''}`}
            role="img"
            hidden={!chapter.activity.dot}
            aria-label={chapter.label}
            title={chapter.label}/>
        </strong>
        <small hidden={!chapter.status}>{chapter.status}</small>
        <small hidden={!chapter.next}>{chapter.next}</small>
        <small>{chapter.story}</small>
      </a>
    ))
  ) : (
    <p class="menu-empty">{state.empty}</p>
  );
}
